import { Component, inject, Input, OnInit } from '@angular/core';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import { P0003606DetectionFinBidonModalComponent } from '../../../P0003606/Modal/p0003606-detection-fin-bidon-modal/p0003606-detection-fin-bidon-modal.component';
import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { LargedLinkComponent } from '../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { SwitchConfigurationComponent } from '../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { P0003606SensContactEnum } from '../../../P0003606/Enum/P0003606SensContactEnum';
import { LabelConfigurationComponent } from '../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { P0003606DureeLimiteSurdosage } from '../../../P0003606/Enum/P0003606DureeLimiteSurdosage';
import { P0003607DureeInversion } from '../../Enum/P0003607DureeInversion';
import { P0003607PositionTypeEnum } from '../../Enum/P0003607PositionTypeEnum';
import { LabelDescriptionComponent } from '../../../../../../../components/ecosystems/label-description/label-description.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SlideModalController } from '../../../../../../slide-modal.service';
import { FunctionEnSavoirPlusModalComponent } from '../../../../../../../components/ecosystems/function-en-savoir-plus-modal/function-en-savoir-plus-modal.component';
import { TwoChoicesModalComponent } from '../../../../../../../components/ecosystems/two-choices-modal/two-choices-modal.component';
import { P0003607ESPPolariteComponent } from '../../Electrolyseur/EnSavoirPlus/p0003607-esppolarite/p0003607-esppolarite.component';

@Component({
  selector: 'app-p0003607-installation-cellule',
  templateUrl: './p0003607-installation-cellule.component.html',
  styleUrls: ['./p0003607-installation-cellule.component.scss'],
  standalone: true,
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    LargedLinkComponent,
    SwitchConfigurationComponent,
    TranslatePipe,
    LabelConfigurationComponent,
    LabelDescriptionComponent,
  ],
})
export class P0003607InstallationCelluleComponent implements OnInit {
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  public currentForm: FormGroup | null = null;
  private modalController = inject(ModalController);
  private slideModalController = inject(SlideModalController);
  private fb = inject(FormBuilder);

  constructor() {
    this.P0003607ESPPolariteModal = this.P0003607ESPPolariteModal.bind(this);
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
    this.initForm();
  }

  private initForm() {
    this.currentForm = this.fb.group({
      position: [this.poolAdditionalData?.positionCellule ?? 0, []],
    });
  }

  async P0003607ESPPolariteModal() {
    const modal = await this.slideModalController.create({
      component: P0003607ESPPolariteComponent,
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  async openModal() {
    const modal = await this.modalController.create({
      component: TwoChoicesModalComponent,
      componentProps: {
        title: 'P0003607.modal.positiontype.title',
        value: this.currentForm!.controls['position'].value,
        firstChoice: {
          title: 'P0003607.modal.positiontype.option0',
          image:
            '/assets/ecosystem/images/products/P0003607/P0003607-positioncellule-0.png',
          value: 0,
        },
        secondChoice: {
          title: 'P0003607.modal.positiontype.option1',
          image:
            '/assets/ecosystem/images/products/P0003607/P0003607-positioncellule-1.png',
          value: 1,
        },
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.currentForm!.controls['position'].setValue(data.value);
    }
  }

  onSubmit() {
    this.poolAdditionalData!.positionCellule =
      this.currentForm!.controls['position']?.value;

    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P0003606SensContactEnum = P0003606SensContactEnum;
  protected readonly P0003606DureeLimiteSurdosage =
    P0003606DureeLimiteSurdosage;
  protected readonly P0003607DureeInversion = P0003607DureeInversion;
  protected readonly P0003607PositionTypeEnum = P0003607PositionTypeEnum;
}
